import axiosPrivate from "./axiosPrivate";

const getRendiciones = () => {
  return axiosPrivate.get("rendicion-viaticos")
    .then(response => response.data);
};

const getPlanillasDisponibles = (usuarioId) => {
  return axiosPrivate.get(`rendicion-viaticos/planillas-disponibles/${usuarioId}`)
    .then(response => response.data);
};

const insertRendicion = (data) => {
  return axiosPrivate.post("rendicion-viaticos", data)
    .then(response => response.data);
};

const updateRendicion = (id, data) => {
  return axiosPrivate.put(`rendicion-viaticos/${id}`, data)
    .then(response => response.data);
};

const deleteRendicion = (id) => {
  return axiosPrivate.delete(`rendicion-viaticos/${id}`)
    .then(response => response.data);
};

const getArchivosAdjuntos = (id) => {
  const formData = new FormData();
  formData.append('origen_id', id);
  return axiosPrivate.post('getDocumentosRendicion', formData)
    .then(response => response.data);
};

const subirArchivosAdjuntos = (id, data) => {
  return axiosPrivate.post('guardarDocumentosRendicion', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    }
  }).then(response => response.data);
};

const eliminarArchivoAdjunto = (archivoId) => {
  const formData = new FormData();
  formData.append('archivo_id', archivoId);
  return axiosPrivate.post('eliminarDocumentoRendicion', formData)
    .then(response => response.data);
};

const validarRendicion = (id, data) => {
  return axiosPrivate.post(`rendicion-viaticos/${id}/validar`, data)
    .then(response => response.data);
};

export default {
    getRendiciones,
    getPlanillasDisponibles,
    insertRendicion,
    updateRendicion,
    deleteRendicion,
    getArchivosAdjuntos,
    subirArchivosAdjuntos,
    eliminarArchivoAdjunto,
    validarRendicion
};
